const $Common = {
  all: "전체",
  cancel: "취소",
  delete: "삭제",
  modification: "수정",
  cancelModification: "수정 취소",
  confirmDelete: "삭제하면 복구할 수 없습니다. 계속하시겠습니까?",
  message: "메세지",
  greeting: "안녕하세요!",
  goodbye: "안녕히 가세요!",
  none: "없음",
  ok: "확인",
  or: "또는",
  subtitle: "",
  title: "",
  unknown: "모름",
  userManagement: "유저 관리",
  serviceName: "StroKcare",
  language: "언어",
  dashboard: "대시보드",
  content: "",
  save: "저장하기",
  nodata: "데이터가 없습니다.",
  points: "점",

  // 날짜 관련
  weekdaysLong: "일요일 월요일 화요일 수요일 목요일 금요일 토요일",
  weekdaysShort: "일 월 화 수 목 금 토",
  today: "오늘",
  yesterday: "어제",
  weekly: "주간",
  daily: "일간",
  monthly: "월간",
  year: "년(4자)",
  month: "월",
  day: "일",
  second: "초",
  before: "이전",
  monday: "월",
  tuesday: "화",
  wednesday: "수",
  thursday: "목",
  friday: "금",
  saturday: "토",
  sunday: "일",

  // 환자 관련
  displayName: "이름",
  patientCode: "이용권 번호",
  age: "나이",
  birth: "생년월일",
  gender: "성별",
  state: "상태",
  lastEvaluationDt: "마지막 평가",
  male: "남",
  female: "여",
  phone: "휴대전화",
  address: "주소",
  firstOutbreakDt: "최초 발병일",
  recentVisitDt: "최근 방문일",
  diseaseType: "질병 타입",
  disabilityType: "장애 타입",
  authenticationNumber: "인증코드",
  email: "이메일",

  required: "필수 입력 항목입니다.",
  notValidBlanked: "공백은 입력할 수 없습니다.",
  notValidEmail: "이메일 형식이 올바르지 않습니다.",
  notValidPhone: "휴대전화 형식이 올바르지 않습니다.",
  lessThanNumCharacter: "{msg}자 이하로 입력해주세요.",
  moreThanNumCharacter: "{msg}자 이상으로 입력해주세요.",
  moreThanNum: "{msg} 이상으로 입력해주세요.",
};

const $Report = {
  Achievement: "성취 추구",
  Responsibility: "책임 의식",
  Attention: "주의력",
  Sadness: "슬픔 조절",
  Anger: "분노 조절",
  Resilience: "자아 탄력성",
  Mindful: "챙김력",
  Monitoring: "모니터링",
  Neat: "정리 정돈",
  anxiety: "평정심 유지",
  gloom: "기분 안정",
  stress: "스트레스 대처",
  selfControl: "자기 통제",
  mood: "기분 조절",
  metaCognitive: "메타 인지",
  mindState: "마음 상태",
};

export const ko = {
  AppBar: {
    ...$Common,
  },
  TriangleChart: {
    ...$Common,
    ...$Report,
  },
  StateExpansionItem: {
    ...$Common,
    ...$Report,
  },
};
